import { useEffect, useState } from 'react';

export function GhibliBackground() {
  const [clouds, setClouds] = useState<number[]>([]);
  const [leaves, setLeaves] = useState<number[]>([]);

  useEffect(() => {
    // Generate random clouds
    setClouds(Array.from({ length: 5 }, (_, i) => i));
    // Generate random leaves with different colors
    setLeaves(Array.from({ length: 20 }, (_, i) => i));
  }, []);

  const getLeafColor = (index: number) => {
    const colors = [
      '#86efac', // light green
      '#4ade80', // green
      '#fb7185', // rose
      '#f472b6', // pink
      '#fcd34d', // amber/gold (autumn feel)
    ];
    return colors[index % colors.length];
  };

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden bg-linear-to-br from-blue-50 to-indigo-50/50">
      {/* Sky Gradient Overlay - adds depth to the background color */}
      <div className="absolute inset-0 bg-linear-to-b from-blue-50/40 to-transparent" />

      {/* Clouds */}
      {clouds.map((i) => (
        <div
          key={`cloud-${i}`}
          className="absolute opacity-60 animate-float-slow will-change-transform"
          style={{
            top: `${Math.random() * 40}%`,
            left: `${Math.random() * 100}%`,
            animationDuration: `${20 + Math.random() * 40}s`,
            animationDelay: `${Math.random() * -20}s`,
            transform: `scale(${0.5 + Math.random()})`,
          }}
        >
          <div className="w-32 h-12 bg-white rounded-full blur-xl opacity-80" />
          <div className="w-20 h-20 bg-white rounded-full blur-xl opacity-80 -mt-8 ml-6" />
          <div className="w-24 h-16 bg-white rounded-full blur-xl opacity-80 -mt-6 ml-16" />
        </div>
      ))}

      {/* Falling Leaves/Petals */}
      {leaves.map((i) => (
        <div
          key={`leaf-${i}`}
          className="absolute animate-falling will-change-transform"
          style={{
            left: `${(i * 7) % 100}%`, // Distribute horizontally
            top: `-10%`,
            animationDuration: `${15 + (i % 10)}s`, // Varied duration
            animationDelay: `${i * 2}s`, // Staggered start
            opacity: 0.6,
            transform: `scale(${0.5 + (i % 5) * 0.1})`,
          }}
        >
          <div className="animate-sway will-change-transform" style={{ animationDuration: `${3 + (i % 3)}s` }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C12 2 13 8 18 12C13 13 12 22 12 22C12 22 11 13 6 12C11 8 12 2 12 2Z" 
                fill={getLeafColor(i)} 
                className="opacity-80 drop-shadow-sm" 
              />
            </svg>
          </div>
        </div>
      ))}

      {/* Floating Particles/Dust Motes (like in Totoro/Spirited Away) */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8L3N2Zz4=')] opacity-30 animate-pulse will-change-opacity" />
    </div>
  );
}
